import { QueryClientProvider as TanStackQueryClientProvider } from "@tanstack/react-query"
import { ReactNode } from "react"
import { queryClient } from "@/shared/lib/react-query/query-client"

type QueryClientProviderProps = {
  children: ReactNode
}

export function QueryClientProvider(props: Readonly<QueryClientProviderProps>) {
  const { children } = props
  return (
    <TanStackQueryClientProvider client={queryClient}>
      {children}
    </TanStackQueryClientProvider>
  )
}
